import { __assign } from "tslib";
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { Grid, TextField, MenuItem, makeStyles } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useConfigs } from "../config-provider";
import { getStartAndEndTime } from "./utils";
var useStyles = makeStyles(function () {
  return {
    select: {
      background: "white !important"
    }
  };
});

function useControlled(_a) {
  var controlled = _a.controlled,
      defaultProp = _a.default;
  var isControlled = useRef(controlled !== undefined).current;

  var _b = useState(defaultProp),
      valueState = _b[0],
      setValue = _b[1];

  var value = isControlled ? controlled : valueState;
  var setValueIfUncontrolled = useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var TimeFilter = function TimeFilter(props) {
  var _a = props.defaultValue,
      defaultValue = _a === void 0 ? {
    startDateTime: null,
    endDateTime: null,
    dateType: "all"
  } : _a,
      value = props.value,
      size = props.size,
      _b = props.label,
      label = _b === void 0 ? "" : _b,
      anchorRef = props.anchorRef,
      classes = props.classes,
      className = props.className,
      style = props.style,
      startAdornment = props.startAdornment,
      onChange = props.onChange;
  var locale = useConfigs().locale;
  var styles = useStyles();

  var _c = useState(1),
      refresh = _c[1];

  var _d = useControlled({
    controlled: value,
    default: defaultValue
  }),
      state = _d[0],
      setState = _d[1];

  var textRef = useRef(null);

  var _e = useState(0),
      menuWidth = _e[0],
      setMenuWidth = _e[1];

  var options = React.useMemo(function () {
    return [{
      value: "all",
      label: locale.common.all
    }, {
      value: "oneHour",
      label: locale.DateRange.oneHour
    }, {
      value: "today",
      label: locale.DateRange.today
    }, {
      value: "oneWeek",
      label: locale.DateRange.oneWeek
    }, {
      value: "oneMonth",
      label: locale.DateRange.oneMonth
    }, {
      value: "oneYear",
      label: locale.DateRange.oneYear
    }, {
      value: "customized",
      label: locale.DateRange.customized
    }];
  }, [locale]);
  useEffect(function () {
    if (textRef !== null && textRef.current !== null && startAdornment !== undefined) {
      var rect = textRef.current.getBoundingClientRect();
      setMenuWidth(rect.width);
    }
  }, [textRef, startAdornment]);

  function handleChangeDate(key) {
    return function (date) {
      var _a;

      if (date) {
        date.seconds(0);
        date.milliseconds(0);
      }

      var newState = __assign(__assign({}, state), (_a = {}, _a[key] = date, _a));

      setState(newState);
      onChange && onChange(newState);
    };
  }

  function handleChangeType(newType) {
    var _a = getStartAndEndTime(newType, state.startDateTime, state.endDateTime),
        startTime = _a.startTime,
        endTime = _a.endTime;

    var newState = {
      startDateTime: startTime,
      endDateTime: endTime,
      dateType: newType
    };
    setState(newState);
    onChange && onChange(newState);
  }

  function renderDateTime() {
    if (state.dateType !== "customized") {
      return null;
    }

    return React.createElement(Grid, {
      container: true,
      spacing: 3
    }, React.createElement(MuiPickersUtilsProvider, {
      utils: MomentUtils
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(KeyboardDatePicker, {
      label: locale.DateRange.startDate,
      format: "YYYY/MM/DD",
      size: size,
      clearable: true,
      value: state.startDateTime || null,
      onChange: handleChangeDate("startDateTime"),
      keyboardIcon: React.createElement(CalendarTodayIcon, null)
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(KeyboardDatePicker, {
      label: locale.DateRange.endDate,
      format: "YYYY/MM/DD",
      size: size,
      clearable: true,
      value: state.endDateTime || null,
      onChange: handleChangeDate("endDateTime"),
      keyboardIcon: React.createElement(CalendarTodayIcon, null)
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(KeyboardTimePicker, {
      label: locale.DateRange.startTime,
      format: "HH:mm:ss",
      size: size,
      clearable: true,
      value: state.startDateTime || null,
      onChange: handleChangeDate("startDateTime"),
      keyboardIcon: React.createElement(AccessTimeIcon, null)
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(KeyboardTimePicker, {
      label: locale.DateRange.endTime,
      size: size,
      format: "HH:mm:ss",
      clearable: true,
      value: state.endDateTime || null,
      onChange: handleChangeDate("endDateTime"),
      keyboardIcon: React.createElement(AccessTimeIcon, null)
    }))));
  }

  useEffect(function () {
    refresh(0);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(TextField, {
    size: size,
    ref: textRef,
    fullWidth: true,
    select: true,
    value: state.dateType,
    classes: classes,
    className: className,
    label: label,
    InputProps: {
      startAdornment: startAdornment ? React.createElement("div", {
        style: {
          display: "flex",
          marginLeft: -4,
          marginRight: 4
        }
      }, startAdornment) : undefined
    },
    SelectProps: {
      classes: {
        select: styles.select
      },
      MenuProps: {
        style: {
          marginTop: size === "medium" ? 56 : 40,
          marginLeft: startAdornment === undefined ? 0 : -40
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        getContentAnchorEl: null
      }
    },
    variant: "outlined",
    style: __assign({
      background: "#fff"
    }, style),
    onChange: function onChange(e) {
      handleChangeType(e.target.value);
    }
  }, options.map(function (option) {
    return React.createElement(MenuItem, {
      style: {
        width: startAdornment ? menuWidth : "auto"
      },
      key: option.value,
      value: option.value
    }, option.label);
  })), anchorRef && anchorRef.current && ReactDOM.createPortal(renderDateTime(), anchorRef.current));
};

export default TimeFilter;